import type { Ref } from 'vue';
import { computed } from 'vue';
import { isAwayTeam, isHandicap, isShowPointDisplayType } from '@/components/betBuilder/betBuilderOddsDisplay';
import type { IBetBuilderMarket, IBetBuilderSelection } from '@/interface/betBuilder';
import { BetBuilderSelectionStatus } from '@/interface/enum';
import { getMarketRule } from '@/libraries/oddsApi/betBuilderMarketRule';

export function useBetBuilderSelection(market: Ref<IBetBuilderMarket>, selection: Ref<IBetBuilderSelection>) {
    const isSuspended = computed(() => selection.value.status === BetBuilderSelectionStatus.Suspended);

    const marketRule = computed(() => getMarketRule(market.value.displayType));

    const shortName = computed(() => marketRule.value.shortNameDisplay(selection.value) || selection.value.type.name);
    const fullName = computed(() => marketRule.value.fullNameDisplay(selection.value) || selection.value.type.name);

    const point = computed(() => {
        if (!isShowPointDisplayType(market.value.displayType)) {
            return '';
        }

        const shouldNegate = isHandicap(market.value.displayType) && isAwayTeam(selection.value.type.id);
        const pointValue = shouldNegate ? -market.value.point : market.value.point;

        return pointValue.toFixed(2);
    });

    return {
        isSuspended,
        shortName,
        fullName,
        point,
    };
}
